export type Locale = 'en' | 'de' | 'tr';

export const messages: Record<Locale, Record<string, string>> = {
    en: {
        'agent.workspace.title': 'Agent workspace',
        'agent.workspace.subtitle': 'Campaign, KPIs, and call controls will appear here.',
        'agent.workspace.kpi.callsToday': 'Calls today',
        'agent.workspace.kpi.salesToday': 'Sales today',
        'agent.workspace.kpi.callbacksToday': 'Callbacks today',
        'agent.workspace.kpi.workTime': 'Work time today',
        'agent.workspace.kpi.pauseTime': 'Pause time today',
    },
    de: {
        'agent.workspace.title': 'Agenten-Arbeitsplatz',
        'agent.workspace.subtitle': 'Kampagne, KPIs und Anrufsteuerung erscheinen hier.',
        'agent.workspace.kpi.callsToday': 'Anrufe heute',
        'agent.workspace.kpi.salesToday': 'Verkäufe heute',
        'agent.workspace.kpi.callbacksToday': 'Rückrufe heute',
        'agent.workspace.kpi.workTime': 'Arbeitszeit heute',
        'agent.workspace.kpi.pauseTime': 'Pausenzeit heute',
    },
    tr: {
        'agent.workspace.title': 'Temsilci çalışma alanı',
        'agent.workspace.subtitle': 'Kampanya, KPI’lar ve arama kontrolleri burada görünecek.',
        'agent.workspace.kpi.callsToday': 'Bugünkü aramalar',
        'agent.workspace.kpi.salesToday': 'Bugünkü satışlar',
        'agent.workspace.kpi.callbacksToday': 'Bugünkü geri aramalar',
        'agent.workspace.kpi.workTime': 'Bugünkü çalışma süresi',
        'agent.workspace.kpi.pauseTime': 'Bugünkü mola süresi',
    },
};
